import getCreatorProfilePageUrl from '@/utils/getCreatorProfilePageUrl';
import {
  CREATOR_ACTION_KEYS,
  CreatorActionKey,
} from '@/views/creators/components/creator-action/creatorActionKeys';
import {isOffPlatformCreator, SourceableCreator} from './offPlatformSource';

export {OFF_PLATFORM_SOURCE, isOffPlatformCreator} from './offPlatformSource';
export type {SourceableCreator} from './offPlatformSource';

export const OFF_PLATFORM_DISABLED_ACTION_KEYS: ReadonlySet<CreatorActionKey> =
  new Set([
    CREATOR_ACTION_KEYS.INVITE_CREATOR,
    CREATOR_ACTION_KEYS.MESSAGE_CREATOR,
    CREATOR_ACTION_KEYS.SEND_EMAIL,
    CREATOR_ACTION_KEYS.CREATE_AND_SHARE_LIST,
    CREATOR_ACTION_KEYS.ADD_NOTE,
  ]);

const OFF_PLATFORM_GATED_BULK_ACTION_IDS: ReadonlySet<string> = new Set([
  'message-creators',
  'recruit-to-crm',
  ...OFF_PLATFORM_DISABLED_ACTION_KEYS,
]);

export function disabledActionKeysForCreator(
  creator?: SourceableCreator | null,
  extra?: Iterable<CreatorActionKey>
): Set<CreatorActionKey> {
  const keys = new Set<CreatorActionKey>(extra ?? []);
  if (isOffPlatformCreator(creator)) {
    OFF_PLATFORM_DISABLED_ACTION_KEYS.forEach((key) => keys.add(key));
  }
  return keys;
}

export function isOffPlatformBulkGatedAction(actionId: string): boolean {
  return OFF_PLATFORM_GATED_BULK_ACTION_IDS.has(actionId);
}

export function crmProfileUrlFor(
  creator: SourceableCreator & {id: string}
): string | undefined {
  if (isOffPlatformCreator(creator) && !creator.userId) {
    return getCreatorProfilePageUrl.fromCrmOffPlatform(creator.id);
  }
  return getCreatorProfilePageUrl.fromCrm(creator.id);
}

export function selectionHasOffPlatform(
  creators: Iterable<SourceableCreator>
): boolean {
  return Array.from(creators).some(isOffPlatformCreator);
}

export function shouldGateOffPlatformBulkActions(
  selectedCreators: Iterable<SourceableCreator>,
  isAllFilterMatchingSelected: boolean
): boolean {
  return (
    isAllFilterMatchingSelected || selectionHasOffPlatform(selectedCreators)
  );
}
